import { render, staticRenderFns } from "./Protocolo.vue?vue&type=template&id=e7da4836"
import script from "./Protocolo.vue?vue&type=script&lang=js"
export * from "./Protocolo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports